import React, { Suspense, lazy } from 'react'
import Loading from '@components/loading'

function LazyLoad(component) {
    const Component = lazy(() => component().catch((error) => {
        const msg = String(error && (error.message || error.name || error))
        const isChunkError = /Loading chunk\s+\d+\s+failed/i.test(msg) || msg.includes('ChunkLoadError')
        if (isChunkError) {
            const key = 'chunk-error-reload'
            const hasReloaded = sessionStorage.getItem(key) === '1'
            if (!hasReloaded) {
                sessionStorage.setItem(key, '1')
                window.location.reload()
                return new Promise(() => {})
            }
            sessionStorage.removeItem(key)
        }
        throw error
    }))

    return (
        <Suspense fallback={<Loading />}>
            <Component />
        </Suspense>
    )
}

export default LazyLoad
